/*
 * @Author: your name
 * @Date: 2021-09-03 10:25:40
 * @LastEditTime: 2021-11-11 15:06:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/api/combination/index.js
 */

// 组合套餐接口；
import ajax from '@/utils/ajax';

const header = '/web';
// 查询套餐详情接口
export const reqCombinationDetail = (packageId) => ajax(`${header}/v1/package/${packageId}`, '', 'post');

// 根据套餐id集合获取套餐基础信息列表
export const reqCombinationlist = (company, endPoint, data) => ajax(`${header}/v1/package/list/${company}/${endPoint}`, data, 'post');

// 查询组合套餐是否购买
export const reqCombinationBuy = (packageId) => ajax(`${header}/v1/user/course/user-is-package?packageId=${packageId}`);

// 查询组合套餐的活动详情
export const reqCombinationAcvitity = (data) => ajax(`${header}/v1/package-detail/discount`, data, 'POST');

// 收藏
export const reqAddCollected = (data) => ajax(`${header}/v1/user/collect`, data, 'POST');

// 取消收藏
export const reqCancelCollect = (id) => ajax(`${header}/v1/user/collect/${id}`, '', 'DELETE');

// 查询是否收藏
export const reqCheckCollect = (sourceId, type) => ajax(`${header}/v1/user/collect?sourceId=${sourceId}&type=${type}`);

// 买课赠券赠实物
export const reqPackageGift = (packageId) => ajax(`${header}/v1/gift/package?packageId=${packageId}`);
